import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import alertsService from '../../../api/services/Alerts/alerts.service';

export interface AlertData {
  id: string;
  categoryTypeId: string;
  categoryTypeName: string;
  title: string;
  description: string;
  createdOn: string;
}

interface AlertsState {
  newAlertsCount: number;
  loading: boolean;
  error: boolean;
}

const initialState: AlertsState = {
  newAlertsCount: 0,
  loading: false,
  error: false,
};

// Used only for the badge count on the navigation icon
export const fetchNewAlertsCount = createAsyncThunk(
  'alerts/fetchNewAlertsCount',
  async (_, { rejectWithValue }) => {
    try {
      const res = await alertsService.getAlerts('Unread', { startIndex: 0, noOfRecords: 1 });
      const data = res?.data?.data;
      return Array.isArray(data) ? data.length : ((data?.totalElements as number) ?? 0);
    } catch {
      return rejectWithValue('Error fetching new alerts count');
    }
  }
);

const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    setNewAlertsCount: (state, action) => {
      state.newAlertsCount = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchNewAlertsCount.pending, state => {
        state.loading = true;
        state.error = false;
      })
      .addCase(fetchNewAlertsCount.fulfilled, (state, action) => {
        state.loading = false;
        state.newAlertsCount = action.payload;
      })
      .addCase(fetchNewAlertsCount.rejected, state => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const { setNewAlertsCount } = alertsSlice.actions;
export default alertsSlice.reducer;
